import { GradientType } from '@/types/GradientType';
import { ColorThemeEnum } from '@/enum/ColorThemeEnum';

export const getGradientByColor = (color: ColorThemeEnum | null): GradientType | null => {
  switch (color) {
  case ColorThemeEnum.DARKBLUE:
    return { start: 'var(--gradient-dark-blue-start)', end: 'var(--gradient-dark-blue-end)' };
  case ColorThemeEnum.DARKBLUE_REVERT:
    return { end: 'var(--gradient-dark-blue-start)', start: 'var(--gradient-dark-blue-end)' };
  case ColorThemeEnum.BLUE:
    return { start: 'var(--gradient-blue-start)', end: 'var(--gradient-blue-end)' };
  case ColorThemeEnum.BLUE_REVERT:
    return { end: 'var(--gradient-blue-start)', start: 'var(--gradient-blue-end)' };
  case ColorThemeEnum.PURPLE:
    return { start: 'var(--gradient-violet-start)', end: 'var(--gradient-violet-end)' };
  case ColorThemeEnum.PURPLE_REVERT:
    return { end: 'var(--gradient-violet-start)', start: 'var(--gradient-violet-end)' };
  case ColorThemeEnum.ORANGE:
    return { start: 'var(--gradient-orange-start)', end: 'var(--gradient-orange-end)' };
  case ColorThemeEnum.ORANGE_REVERT:
    return { end: 'var(--gradient-orange-start)', start: 'var(--gradient-orange-end)' };
  case ColorThemeEnum.GREEN:
    return { start: 'var(--gradient-green-start)', end: 'var(--gradient-green-end)' };
  case ColorThemeEnum.GREEN_REVERT:
    return { end: 'var(--gradient-green-start)', start: 'var(--gradient-green-end)' };
  case ColorThemeEnum.WHITE:
    return { start: 'var(--white)', end: 'var(--white' };
  default:
    return null;
  }
};
